export enum Region {
  De = 'DE',
  At = 'AT',
  Ch = 'CH',
  Fr = 'FR',
  It = 'IT',
  Be = 'BE',
  Nl = 'NL',
}
